import { render, staticRenderFns } from "./VQuestion.vue?vue&type=template&id=7ccc8fbd"
import script from "./VQuestion.vue?vue&type=script&lang=js"
export * from "./VQuestion.vue?vue&type=script&lang=js"
import style0 from "./VQuestion.vue?vue&type=style&index=0&id=7ccc8fbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../home/michael/.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports